import { Check, ChevronDown } from 'lucide-react'

import { Button } from '~/components/component-library'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/components/component-library/Dropdown/primitives'

// A compact label-triggered selector for the simulator toolbar. Built from CL
// dropdown primitives so it themes itself in light and dark mode, and opens
// upward since the toolbar is pinned to the bottom of the screen.
export const SimSelect = ({
  label,
  items,
  activeId,
  onSelect,
}: {
  label: string
  items: { id: string; label: string }[]
  activeId: string | null
  onSelect: (id: string) => void
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="secondary" size="small" suffix={<ChevronDown />}>
        {label}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent side="top" align="end" sideOffset={8}>
      {items.map((item) => (
        <DropdownMenuItem
          key={item.id}
          onClick={() => onSelect(item.id)}
          className="justify-between gap-6"
        >
          {item.label}
          {activeId === item.id && <Check />}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
)
